import { isBasicOnboardingDone } from 'src/mentor/helpers/utilityFunctions'

export function hasCompletedConsumerOnboarding(profileData) {
  if (!profileData) {
    return false
  }

  if (profileData?.info?.USER_ON_BOARD) {
    return true
  }

  if (!isBasicOnboardingDone(profileData)) {
    return false
  }

  const studentPersonalize = profileData?.personalize?.studentPersonalize || {}
  const persona = studentPersonalize?.persona || {}
  const mentalHealthProfessional = studentPersonalize?.mentalHealthProfessional || {}

  const hasPersonaSelections = [
    persona?.category,
    persona?.focusAreas,
    persona?.bodyTopics,
    persona?.mindTopics,
    persona?.soulTopics,
    persona?.primaryTopics,
    persona?.secondaryTopics,
  ].some((items) => Array.isArray(items) && items.length > 0)

  const hasProfessionalPreference =
    mentalHealthProfessional?.iamMentalHealthProfessional === true ||
    Boolean(mentalHealthProfessional?.workingWithMentalHealthProfessional)

  return (
    Boolean(studentPersonalize?.acquisitionId) ||
    hasPersonaSelections ||
    (Boolean(studentPersonalize?.primaryPath) && hasProfessionalPreference)
  )
}
